import { Card } from 'primereact/card';
import React, { useState } from 'react';
import DataTableTabelaPreco from './DataTableTabelaPreco.jsx';
import FiltrosPesquisa from './FiltrosPesquisa.jsx';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import CompareArrowsOutlinedIcon from '@material-ui/icons/CompareArrowsOutlined';
import { ToggleButton } from '@material-ui/lab';
import  './style.css';

const header = <img alt="Card" src={FundoAmarelo} />;

export default function TabelaPreco() {
    const [dadosTabela,setDadosTabela] = useState('');
    const [tipoPesquisa,setTipoPesquisa] = useState('Adesao');
    const [loadingTabela,setLoadingTabela] = useState(false);

    const [paginaDeBusca, setPaginaDeBusca] = useState(1);
    const [paginaAtualDataTable, setPaginaAtualDataTable] = useState(0);
    const [paginasTotaisDataTable, setPaginasTotaisDataTable] = useState(0);
    const [itensPorPaginaDataTable, setItensPorPaginaDataTable] = useState(10);
    const [primeiroItenParaMostrarDataTable, setPrimeiroItenParaMostrarDataTable] = useState(0);
    const [paginaAnterior, setPaginaAnterior] = useState(0);
    const [naoPossuiMaisRegistros, setNaoPossuiMaisRegistros] = useState(false);

    const setters = {
        setPaginaDeBusca,
        setPaginaAtualDataTable,
        setPaginasTotaisDataTable,
        setItensPorPaginaDataTable,
        setPrimeiroItenParaMostrarDataTable,
        setPaginaAnterior,
        setNaoPossuiMaisRegistros,
        setLoadingTabela,
        setDadosTabela
    };

    const states = {
        tipoPesquisa,
        paginaDeBusca,
        paginaAtualDataTable,
        paginasTotaisDataTable,
        itensPorPaginaDataTable,
        primeiroItenParaMostrarDataTable,
        paginaAnterior,
        naoPossuiMaisRegistros,
        dadosTabela,
        loadingTabela
    };

    return <>
        <Card className='tratar-scroll-card' header={header} title={'Tabela de preços'}>
            <div className='container-principal'>
                <p>Selecione o tipo de pesquisa: </p>
                <ToggleButton
                    value={tipoPesquisa}
                    style={{
                        margin: '6px 0',
                        width: '13rem',
                        color: '#101C85',
                        borderColor: '#101C85'
                    }}
                    onChange={(_, novoValor) => {
                        if (novoValor === 'Adesao') {
                            setTipoPesquisa('Mensalidade');
                        } else {
                            setTipoPesquisa('Adesao');
                        }

                        setDadosTabela([]);
                    }}
                >
                    {tipoPesquisa}
                    <CompareArrowsOutlinedIcon />
                </ToggleButton>
                <FiltrosPesquisa states={states} setters={setters}/>
                <DataTableTabelaPreco states={states} setters={setters} />

            </div>
        </Card>

    </>;
}
